import { render, staticRenderFns } from "./ConversationNavigationButtons.vue?vue&type=template&id=5ef77941&"
import script from "./ConversationNavigationButtons.vue?vue&type=script&lang=js&"
export * from "./ConversationNavigationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports